import {useCallback, useContext, useState} from "react";
import {isCurrentPageDenyQuery, runApi, useStartApi} from "../services/api/ApiContext";
import {getUserIdps, linkUserIdps, unlinkUserIdps} from "../services/api/profileApi";
import {useOktaAuth} from "@okta/okta-react";
import {toast} from "react-toastify";
import {useLocation} from "react-use";

const {createContext} = require("react");

const idpsContext = createContext(null);

const getUserIdpsApiProcess = ({data}) => data?.data?.idps;

export const IdpsProvider = ({children}) => {
	const {authState} = useOktaAuth();
	const location = useLocation();
	const [lastUpdate, forceUpdate] = useState(-1);
	const denyQuery = isCurrentPageDenyQuery(location)

	const {data} = useStartApi(['getIdps', lastUpdate, authState?.accessToken], getUserIdps, getUserIdpsApiProcess, {
		enabled: !denyQuery && !!authState?.isAuthenticated && !!authState?.accessToken,
	});

	const refresh = useCallback(() => forceUpdate(Date.now), [forceUpdate]);

	const linkIdp = useCallback(async (idpId, externalId) => {
		const {error} = await runApi(
			'linkIdp',
			() => linkUserIdps(idpId, externalId),
		);

		if(!error) {
			toast.success("Link successfully");
		}

		refresh();

		return !error;
	}, [refresh]);

	const unlinkIdp = async (idpId) => {
		const {error} = await runApi(
			'unlinkIdp',
			() => unlinkUserIdps(idpId),
		);

		if(!error) {
			toast.success("Unlink successfully");
		}

		refresh();
	};

	return (
		<idpsContext.Provider value={{
			data,
			linkIdp,
			unlinkIdp,
			refresh,
		}}>
			{children}
		</idpsContext.Provider>
	);
}

export const useIdps = () => useContext(idpsContext);
